/**
* Do not edit directly
* Generated on Fri, 11 Jul 2025 22:18:21 GMT
*/
module.exports = {
  border: {
    border1: 1,
    border2: 2,
    border3: 3,
    border4: 4,
    none: 0
  },
  color: {
    amaranth: '#ee2c74',
    bilbao: '#258b0b',
    black: '#000000',
    blackLight: '#404040',
    blue: '#2dccd3',
    blueDark: '#15b8bf',
    blueLight: '#abebee',
    caution: '#f8c100',
    cautionLight: '#fff5d2',
    danger: '#c9370b',
    dangerLight: '#fcd3c6',
    dangerMid: '#f3592b',
    dark10: 'rgba(0, 0, 0, 0.1)',
    dark20: 'rgba(0, 0, 0, 0.2)',
    dark40: 'rgba(0, 0, 0, 0.4)',
    dark5: 'rgba(0, 0, 0, 0.05)',
    dark60: 'rgba(0, 0, 0, 0.6)',
    dark80: 'rgba(0, 0, 0, 0.8)',
    dark97: 'rgba(0, 0, 0, 0.97)',
    dove: '#666666',
    flirt: '#7c1366',
    gallery: '#efefef',
    green: '#a1ed00',
    greenDark: '#8ed000',
    greenLight: '#dfff9a',
    greyLight: '#fafafa',
    greyMystic: '#e3e6e8',
    light10: 'rgba(255, 255, 255, 0.1)',
    light20: 'rgba(255, 255, 255, 0.2)',
    light40: 'rgba(255, 255, 255, 0.4)',
    light60: 'rgba(255, 255, 255, 0.6)',
    light80: 'rgba(255, 255, 255, 0.8)',
    light97: 'rgba(255, 255, 255, 0.97)',
    mortar: '#595959',
    mosque: '#016b6a',
    orange: '#ffad00',
    orangeDark: '#e49b00',
    orangeLight: '#ffd478',
    pink: '#ff0076',
    pinkDark: '#dd0066',
    pinkLight: '#ffd1e6',
    purple: '#7a3dfc',
    purpleDark: '#5b2bc2',
    purpleLight: '#e0d8fc',
    silver: '#c9c8c8',
    silverDark: '#b5b4b4',
    success: '#1c7b2b',
    successLight: '#c5f2cc',
    transparent: 'rgba(0, 0, 0, 0)',
    trinidad: '#df3d0c',
    white: '#ffffff'
  },
  duration: {
    duration250: 250,
    duration300: 300
  },
  font: {
    StagSans: {
      300: '@telus-uds/palette-koodo/build/rn/fonts/StagSans-Light.otf',
      400: '@telus-uds/palette-koodo/build/rn/fonts/StagSans-Regular.otf',
      500: '@telus-uds/palette-koodo/build/rn/fonts/StagSans-Medium.otf',
      600: '@telus-uds/palette-koodo/build/rn/fonts/StagSans-Semibold.otf',
      700: '@telus-uds/palette-koodo/build/rn/fonts/StagSans-Bold.otf'
    },
    StagSansWoff: {
      300: '@telus-uds/palette-koodo/build/rn/fonts/StagSans-Light.woff',
      400: '@telus-uds/palette-koodo/build/rn/fonts/StagSans-Regular.woff',
      500: '@telus-uds/palette-koodo/build/rn/fonts/StagSans-Medium.woff',
      600: '@telus-uds/palette-koodo/build/rn/fonts/StagSans-Semibold.woff',
      700: '@telus-uds/palette-koodo/build/rn/fonts/StagSans-Bold.woff'
    },
    StagSansWoff2: {
      300: '@telus-uds/palette-koodo/build/rn/fonts/StagSans-Light2.woff2',
      400: '@telus-uds/palette-koodo/build/rn/fonts/StagSans-Regular2.woff2',
      500: '@telus-uds/palette-koodo/build/rn/fonts/StagSans-Medium2.woff2',
      600: '@telus-uds/palette-koodo/build/rn/fonts/StagSans-Semibold2.woff2',
      700: '@telus-uds/palette-koodo/build/rn/fonts/StagSans-Bold2.woff2'
    }
  },
  fontSize: {
    size12: 12,
    size14: 14,
    size15: 15,
    size16: 16,
    size18: 18,
    size2: 2,
    size20: 20,
    size24: 24,
    size28: 28,
    size30: 30,
    size32: 32,
    size34: 34,
    size36: 36,
    size40: 40,
    size44: 44,
    size48: 48,
    size54: 54,
    size56: 56,
    size64: 64,
    size70: 70,
    size72: 72
  },
  gradient: {
    blackSolid: {
      type: 'linear',
      stops: [
        {
          stop: 0,
          color: '#000000'
        },
        {
          stop: 1,
          color: '#000000'
        }
      ],
      angle: 0
    }
  },
  icon: {
    Add: '@telus-uds/palette-koodo/build/rn/icons/add.icon.svg',
    Amex: '@telus-uds/palette-koodo/build/rn/icons/amex.icon.svg',
    AndroidEN: '@telus-uds/palette-koodo/build/rn/icons/android-en.icon.svg',
    AndroidFR: '@telus-uds/palette-koodo/build/rn/icons/android-fr.icon.svg',
    ArrowDownCircled: '@telus-uds/palette-koodo/build/rn/icons/arrow-down-circled.icon.svg',
    ArrowLeft: '@telus-uds/palette-koodo/build/rn/icons/arrow-left.icon.svg',
    ArrowRight: '@telus-uds/palette-koodo/build/rn/icons/arrow-right.icon.svg',
    Bank: '@telus-uds/palette-koodo/build/rn/icons/bank.icon.svg',
    BankFilled: '@telus-uds/palette-koodo/build/rn/icons/bank-filled.icon.svg',
    BoxOutline: '@telus-uds/palette-koodo/build/rn/icons/box-outline.icon.svg',
    BoxOutlineChecked: '@telus-uds/palette-koodo/build/rn/icons/box-outline-checked.icon.svg',
    Bullet: '@telus-uds/palette-koodo/build/rn/icons/bullet.icon.svg',
    BulletCircle: '@telus-uds/palette-koodo/build/rn/icons/bullet-circle.icon.svg',
    BulletFill: '@telus-uds/palette-koodo/build/rn/icons/bullet-fill.icon.svg',
    CanadaFilled: '@telus-uds/palette-koodo/build/rn/icons/canada-filled.icon.svg',
    Cart: '@telus-uds/palette-koodo/build/rn/icons/cart.icon.svg',
    CartFilled: '@telus-uds/palette-koodo/build/rn/icons/cart-filled.icon.svg',
    CartFilledMulti: '@telus-uds/palette-koodo/build/rn/icons/cart-filled-multi.icon.svg',
    Caution: '@telus-uds/palette-koodo/build/rn/icons/caution.icon.svg',
    Check: '@telus-uds/palette-koodo/build/rn/icons/check.icon.svg',
    CheckCircle: '@telus-uds/palette-koodo/build/rn/icons/check-circle.icon.svg',
    CheckCircleFilled: '@telus-uds/palette-koodo/build/rn/icons/check-circle-filled.icon.svg',
    CheckCircledFilled: '@telus-uds/palette-koodo/build/rn/icons/check-circled-filled.icon.svg',
    CheckCircledNotFilled: '@telus-uds/palette-koodo/build/rn/icons/check-circled-not-filled.icon.svg',
    ChevronDown: '@telus-uds/palette-koodo/build/rn/icons/chevron-down.icon.svg',
    ChevronLeft: '@telus-uds/palette-koodo/build/rn/icons/chevron-left.icon.svg',
    ChevronLeftCircle: '@telus-uds/palette-koodo/build/rn/icons/chevron-left-circle.icon.svg',
    ChevronRight: '@telus-uds/palette-koodo/build/rn/icons/chevron-right.icon.svg',
    ChevronRightCircle: '@telus-uds/palette-koodo/build/rn/icons/chevron-right-circle.icon.svg',
    ChevronUp: '@telus-uds/palette-koodo/build/rn/icons/chevron-up.icon.svg',
    CircledLine: '@telus-uds/palette-koodo/build/rn/icons/circled-line.icon.svg',
    Clipboard: '@telus-uds/palette-koodo/build/rn/icons/clipboard.icon.svg',
    Close: '@telus-uds/palette-koodo/build/rn/icons/close.icon.svg',
    ClosedCaptions: '@telus-uds/palette-koodo/build/rn/icons/closed-captions.icon.svg',
    Coaxial: '@telus-uds/palette-koodo/build/rn/icons/coaxial.icon.svg',
    CreditCard: '@telus-uds/palette-koodo/build/rn/icons/credit-card.icon.svg',
    DSL: '@telus-uds/palette-koodo/build/rn/icons/dsl.icon.svg',
    Devices: '@telus-uds/palette-koodo/build/rn/icons/devices.icon.svg',
    Download: '@telus-uds/palette-koodo/build/rn/icons/download.icon.svg',
    ExclamationOctagon: '@telus-uds/palette-koodo/build/rn/icons/exclamation-octagon.icon.svg',
    ExclamationTriangle: '@telus-uds/palette-koodo/build/rn/icons/exclamation-triangle.icon.svg',
    Expand: '@telus-uds/palette-koodo/build/rn/icons/expand.icon.svg',
    EyeClosed: '@telus-uds/palette-koodo/build/rn/icons/eye-closed.icon.svg',
    EyeMasked: '@telus-uds/palette-koodo/build/rn/icons/eye-masked.icon.svg',
    EyeOpened: '@telus-uds/palette-koodo/build/rn/icons/eye-opened.icon.svg',
    EyeUnmasked: '@telus-uds/palette-koodo/build/rn/icons/eye-unmasked.icon.svg',
    Fingerprint: '@telus-uds/palette-koodo/build/rn/icons/fingerprint.icon.svg',
    FullscreenExpand: '@telus-uds/palette-koodo/build/rn/icons/fullscreen-expand.icon.svg',
    FullscreenMinimize: '@telus-uds/palette-koodo/build/rn/icons/fullscreen-minimize.icon.svg',
    Gift: '@telus-uds/palette-koodo/build/rn/icons/gift.icon.svg',
    Hamburger: '@telus-uds/palette-koodo/build/rn/icons/hamburger.icon.svg',
    IOSEN: '@telus-uds/palette-koodo/build/rn/icons/iosen.icon.svg',
    IOSFR: '@telus-uds/palette-koodo/build/rn/icons/iosfr.icon.svg',
    IdCard: '@telus-uds/palette-koodo/build/rn/icons/id-card.icon.svg',
    IdTag: '@telus-uds/palette-koodo/build/rn/icons/id-tag.icon.svg',
    Info: '@telus-uds/palette-koodo/build/rn/icons/info.icon.svg',
    InfoSelected: '@telus-uds/palette-koodo/build/rn/icons/info-selected.icon.svg',
    InformationCircled: '@telus-uds/palette-koodo/build/rn/icons/information-circled.icon.svg',
    InternetSpeed: '@telus-uds/palette-koodo/build/rn/icons/internet-speed.icon.svg',
    Kebab: '@telus-uds/palette-koodo/build/rn/icons/kebab.icon.svg',
    LeftCircle: '@telus-uds/palette-koodo/build/rn/icons/left-circle.icon.svg',
    LinkExternal: '@telus-uds/palette-koodo/build/rn/icons/link-external.icon.svg',
    LocationMap: '@telus-uds/palette-koodo/build/rn/icons/location-map.icon.svg',
    LocationMapFilled: '@telus-uds/palette-koodo/build/rn/icons/location-map-filled.icon.svg',
    LockFilled: '@telus-uds/palette-koodo/build/rn/icons/lock-filled.icon.svg',
    LockOpenFilled: '@telus-uds/palette-koodo/build/rn/icons/lock-open-filled.icon.svg',
    Maintenance: '@telus-uds/palette-koodo/build/rn/icons/maintenance.icon.svg',
    MaintenanceFilled: '@telus-uds/palette-koodo/build/rn/icons/maintenance-filled.icon.svg',
    MasterCard: '@telus-uds/palette-koodo/build/rn/icons/master-card.icon.svg',
    Muted: '@telus-uds/palette-koodo/build/rn/icons/muted.icon.svg',
    Number1FilledMono: '@telus-uds/palette-koodo/build/rn/icons/number1-filled-mono.icon.svg',
    Number1FilledMulti: '@telus-uds/palette-koodo/build/rn/icons/number1-filled-multi.icon.svg',
    Number2FilledMono: '@telus-uds/palette-koodo/build/rn/icons/number2-filled-mono.icon.svg',
    Number2FilledMulti: '@telus-uds/palette-koodo/build/rn/icons/number2-filled-multi.icon.svg',
    Number3FilledMono: '@telus-uds/palette-koodo/build/rn/icons/number3-filled-mono.icon.svg',
    Number3FilledMulti: '@telus-uds/palette-koodo/build/rn/icons/number3-filled-multi.icon.svg',
    Number4FilledMono: '@telus-uds/palette-koodo/build/rn/icons/number4-filled-mono.icon.svg',
    Number4FilledMulti: '@telus-uds/palette-koodo/build/rn/icons/number4-filled-multi.icon.svg',
    Number5FilledMono: '@telus-uds/palette-koodo/build/rn/icons/number5-filled-mono.icon.svg',
    Number5FilledMulti: '@telus-uds/palette-koodo/build/rn/icons/number5-filled-multi.icon.svg',
    OfferStarFilled: '@telus-uds/palette-koodo/build/rn/icons/offer-star-filled.icon.svg',
    Pause: '@telus-uds/palette-koodo/build/rn/icons/pause.icon.svg',
    PaymentAdd: '@telus-uds/palette-koodo/build/rn/icons/payment-add.icon.svg',
    Perk: '@telus-uds/palette-koodo/build/rn/icons/perk.icon.svg',
    Phone: '@telus-uds/palette-koodo/build/rn/icons/phone.icon.svg',
    PhoneManage: '@telus-uds/palette-koodo/build/rn/icons/phone-manage.icon.svg',
    PhoneTroubleshoot: '@telus-uds/palette-koodo/build/rn/icons/phone-troubleshoot.icon.svg',
    Play: '@telus-uds/palette-koodo/build/rn/icons/play.icon.svg',
    PlaySolid: '@telus-uds/palette-koodo/build/rn/icons/play-solid.icon.svg',
    PlayVideo: '@telus-uds/palette-koodo/build/rn/icons/play-video.icon.svg',
    PlugPlay: '@telus-uds/palette-koodo/build/rn/icons/plug-play.icon.svg',
    Preference: '@telus-uds/palette-koodo/build/rn/icons/preference.icon.svg',
    Price: '@telus-uds/palette-koodo/build/rn/icons/price.icon.svg',
    Profile: '@telus-uds/palette-koodo/build/rn/icons/profile.icon.svg',
    Question: '@telus-uds/palette-koodo/build/rn/icons/question.icon.svg',
    QuestionFilled: '@telus-uds/palette-koodo/build/rn/icons/question-filled.icon.svg',
    QuoteLeft: '@telus-uds/palette-koodo/build/rn/icons/quote-left.icon.svg',
    QuoteLeftArrow: '@telus-uds/palette-koodo/build/rn/icons/quote-left-arrow.icon.svg',
    QuoteRightArrow: '@telus-uds/palette-koodo/build/rn/icons/quote-right-arrow.icon.svg',
    RadialOutline: '@telus-uds/palette-koodo/build/rn/icons/radial-outline.icon.svg',
    RadialOutlineChecked: '@telus-uds/palette-koodo/build/rn/icons/radial-outline-checked.icon.svg',
    Receipt: '@telus-uds/palette-koodo/build/rn/icons/receipt.icon.svg',
    Refresh: '@telus-uds/palette-koodo/build/rn/icons/refresh.icon.svg',
    Replay: '@telus-uds/palette-koodo/build/rn/icons/replay.icon.svg',
    RightCircle: '@telus-uds/palette-koodo/build/rn/icons/right-circle.icon.svg',
    RightCirlce: '@telus-uds/palette-koodo/build/rn/icons/right-cirlce.icon.svg',
    Settings: '@telus-uds/palette-koodo/build/rn/icons/settings.icon.svg',
    SettingsFilled: '@telus-uds/palette-koodo/build/rn/icons/settings-filled.icon.svg',
    SettingsSolid: '@telus-uds/palette-koodo/build/rn/icons/settings-solid.icon.svg',
    ShippingFilled: '@telus-uds/palette-koodo/build/rn/icons/shipping-filled.icon.svg',
    Shop: '@telus-uds/palette-koodo/build/rn/icons/shop.icon.svg',
    Sim: '@telus-uds/palette-koodo/build/rn/icons/sim.icon.svg',
    SimElectronic: '@telus-uds/palette-koodo/build/rn/icons/sim-electronic.icon.svg',
    SimElectronicFilled: '@telus-uds/palette-koodo/build/rn/icons/sim-electronic-filled.icon.svg',
    SimFilled: '@telus-uds/palette-koodo/build/rn/icons/sim-filled.icon.svg',
    Spyglass: '@telus-uds/palette-koodo/build/rn/icons/spyglass.icon.svg',
    Streaming: '@telus-uds/palette-koodo/build/rn/icons/streaming.icon.svg',
    Subtract: '@telus-uds/palette-koodo/build/rn/icons/subtract.icon.svg',
    Tablet: '@telus-uds/palette-koodo/build/rn/icons/tablet.icon.svg',
    Tag: '@telus-uds/palette-koodo/build/rn/icons/tag.icon.svg',
    TagFilled: '@telus-uds/palette-koodo/build/rn/icons/tag-filled.icon.svg',
    Times: '@telus-uds/palette-koodo/build/rn/icons/times.icon.svg',
    TimesCircled: '@telus-uds/palette-koodo/build/rn/icons/times-circled.icon.svg',
    ToolTipFilled: '@telus-uds/palette-koodo/build/rn/icons/tool-tip-filled.icon.svg',
    Tooltip: '@telus-uds/palette-koodo/build/rn/icons/tooltip.icon.svg',
    TooltipSymbol: '@telus-uds/palette-koodo/build/rn/icons/tooltip-symbol.icon.svg',
    Unmuted: '@telus-uds/palette-koodo/build/rn/icons/unmuted.icon.svg',
    User: '@telus-uds/palette-koodo/build/rn/icons/user.icon.svg',
    UserAdd: '@telus-uds/palette-koodo/build/rn/icons/user-add.icon.svg',
    Visa: '@telus-uds/palette-koodo/build/rn/icons/visa.icon.svg'
  },
  letterSpacing: {
    default: 0
  },
  lineHeight: {
    multiply110: 1.1,
    multiply120: 1.2,
    multiply130: 1.3,
    multiply140: 1.4,
    multiply150: 1.5,
    multiply160: 1.6,
    multiply172: 1.72,
    ratio10to7: 1.42857142857,
    ratio11to5: 2.15,
    ratio11to9: 1.22222222222,
    ratio14to1: 1.45,
    ratio15to7: 2.15,
    ratio16to2: 2,
    ratio17to8: 2.13,
    ratio1to1: 1,
    ratio3to2: 1.5,
    ratio4to3: 1.33333333333,
    ratio5to4: 1.25,
    ratio6to5: 1.2,
    ratio7to3: 2.25,
    ratio7to5: 1.4,
    ratio8to5: 1.45,
    ratio8to7: 1.14285714286
  },
  opacity: {
    opacity10: 1,
    opacity3: 0.3,
    opacity5: 0.5,
    opacity8: 0.8
  },
  radius: {
    none: 0,
    pill32: 32,
    radius1: 1,
    radius12: 12,
    radius16: 16,
    radius2: 2,
    radius24: 24,
    radius4: 4,
    radius45: 45,
    radius48: 48,
    radius6: 6,
    radius8: 8,
    radius99: 99
  },
  shadow: {
    elevation1: {
      inset: false,
      offsetX: 0,
      offsetY: 4,
      blur: 8,
      spread: 0,
      color: 'rgba(0, 0, 0, 0.1)'
    },
    elevation2: {
      inset: false,
      offsetX: 0,
      offsetY: 12,
      blur: 12,
      spread: 0,
      color: 'rgba(0, 0, 0, 0.03)'
    },
    elevation3: {
      inset: false,
      offsetX: 0,
      offsetY: 32,
      blur: 32,
      spread: 0,
      color: 'rgba(0, 0, 0, 0.03)'
    },
    none: {
      inset: false,
      offsetX: 0,
      offsetY: 0,
      blur: 0,
      spread: 0,
      color: 'rgba(0, 0, 0, 0)'
    },
    surfaceInset: {
      inset: true,
      offsetX: 0,
      offsetY: 2,
      blur: 2,
      spread: 0,
      color: 'rgba(0, 0, 0, 0.1)'
    },
    surfaceRaised: {
      inset: false,
      offsetX: 0,
      offsetY: 2,
      blur: 2,
      spread: 0,
      color: 'rgba(0, 0, 0, 0.2)'
    }
  },
  size: {
    size0: 0,
    size1: 1,
    size10: 10,
    size12: 12,
    size120: 120,
    size128: 128,
    size13: 13,
    size14: 14,
    size140: 140,
    size144: 144,
    size15: 15,
    size16: 16,
    size162: 162,
    size168: 168,
    size18: 18,
    size184: 184,
    size2: 2,
    size20: 20,
    size21: 21,
    size22: 22,
    size24: 24,
    size26: 26,
    size27: 27,
    size28: 28,
    size288: 288,
    size29: 29,
    size3: 3,
    size32: 32,
    size320: 320,
    size36: 36,
    size4: 4,
    size40: 40,
    size412: 412,
    size44: 44,
    size45: 45,
    size48: 48,
    size480: 480,
    size5: 5,
    size52: 52,
    size53: 53,
    size544: 544,
    size56: 56,
    size576: 576,
    size6: 6,
    size630: 630,
    size64: 64,
    size640: 640,
    size72: 72,
    size768: 768,
    size8: 8,
    size80: 80,
    size96: 96
  }
}
